<template>
    <div class="template-wrapper">
		<h2 class="page-title">{{ $t("renwulist") }}</h2>
		<el-divider></el-divider>
      <el-button @click="addrenwu" v-if="broadcasting_edit === '1'">{{$t('addRenwu')}}</el-button>

	  <template v-if="broadcasting_read === '1'">
		<br />
		<br />
		<el-form ref="storeform" :model="storeform">
			<el-form-item :label="$t('selectStore')">
				<template>
					<div class="" style="display: flex">
						<el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
							<el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
							<el-option v-for="item in storelist" :label="item.storeid+' ('+item.name+')'" :value="item.storeid"></el-option>
						</el-select>
					</div>
				</template>
			</el-form-item>
		</el-form>
	  </template>

	  <template v-if="broadcasting_read === '1'">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs>
        <el-table
            :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            stripe
            style="width: 100%"
            v-if="this.status==0">
            <el-table-column
                v-if="this.status==0"
                prop="plantime"
                :label="$t('scheduleTime')"
                >
            </el-table-column>
            <el-table-column
                v-if="this.status==1 || this.status==-1"
                prop="plantime"
                :label="$t('sendTime')"
                >
            </el-table-column>
            <el-table-column prop="storeid" :label="$t('storeid')">
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('rwtitle')"
            >
            </el-table-column>
            <!--
            <el-table-column
            prop="templateid"
            :label="$t('templateName')"
            >
            </el-table-column>
            
            <el-table-column
            prop="type"
            label="發送形式"
            >
            </el-table-column>   -->
            <el-table-column
                prop="daifatitle"
                :label="$t('memberGroup')"
                >
            </el-table-column>	
            <!--
            <el-table-column
            prop="sendnum"
            :label="$t('sendnum')"
            >
            </el-table-column>-->
            <el-table-column
                v-if="this.status==1 || this.status==-1"
                :label="$t('status')">
                <template slot-scope="scope">
                    <div>{{scope.row.msg}}</div>
                    <!--     <div>{{scope.row.status=='0'?$t('planing'):$t('ending')}}{{scope[0]}}</div> -->
                </template>
            </el-table-column>

            <el-table-column
                v-if="this.status==0"
                prop="plantime"
                :label="$t('adminset')"
                >
                <template slot-scope="scope">
                    <div class="operationVid">
                        <el-button @click="delitem(scope.row.id)">{{ $t("delete") }}</el-button>
                    </div>
                </template>
            </el-table-column>
            <!--
            <el-table-column
                prop="operation"
                label="管理"
                align="center"
                >
                <template slot-scope="scope">
                <div class="operationVid">
                <span class="operationBef" @click="delitem(scope.row.id)"  v-if="scope.row.status=='0'">删除</span>
                
                <span   class="operationBef" @click="baogao(scope.row)"  v-if="scope.row.status=='1'">报告1</span>
                
                <!-- <el-dropdown trigger="click"  >
                        <span class="el-dropdown-link">
                        管理<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="beforeHandleCommand(scope,'订单详情')" >删除</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown> -->	<!--
                </div>
                </template>
            </el-table-column>-->
		 
        </el-table>
        <el-table
            :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            stripe
            style="width: 100%"
            v-if="this.status==1">
            <el-table-column
                v-if="this.status==1 || this.status==-1"
                prop="plantime"
                :label="$t('sendTime')"
                >
            </el-table-column>
            <el-table-column prop="storeid" :label="$t('storeid')">
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('rwtitle')"
            >
            </el-table-column>
            <el-table-column
                prop="daifatitle"
                :label="$t('memberGroup')"
                >
            </el-table-column>	
            <el-table-column
                v-if="this.status==1 || this.status==-1"
                :label="$t('status')">
                <template slot-scope="scope">
                    <div>{{scope.row.msg}}</div>
                    <!--     <div>{{scope.row.status=='0'?$t('planing'):$t('ending')}}{{scope[0]}}</div> -->
                </template>
            </el-table-column>

            <el-table-column
                v-if="this.status==1"
                prop="plantime"
                :label="$t('adminset')"
                >
                <template slot-scope="scope">
                    <div class="operationVid">
                        <el-button @click="broadcastrecord(scope.row)">{{ $t("broadcastRecord") }}</el-button>
                    </div>
                </template>
            </el-table-column>
            <!--
            <el-table-column
                prop="operation"
                label="管理"
                align="center"
                >
                <template slot-scope="scope">
                <div class="operationVid">
                <span class="operationBef" @click="delitem(scope.row.id)"  v-if="scope.row.status=='0'">删除</span>
                
                <span   class="operationBef" @click="baogao(scope.row)"  v-if="scope.row.status=='1'">报告1</span>
                
                <!-- <el-dropdown trigger="click"  >
                        <span class="el-dropdown-link">
                        管理<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="beforeHandleCommand(scope,'订单详情')" >删除</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown> -->	<!--
                </div>
                </template>
            </el-table-column>-->
		 
        </el-table>
        <el-table
            :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            stripe
            style="width: 100%"
            v-if="this.status==-1">
            <el-table-column
                prop="plantime"
                :label="$t('sendTime')"
                >
            </el-table-column>
            <el-table-column prop="storeid" :label="$t('storeid')">
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('rwtitle')"
            >
            </el-table-column>
            <el-table-column
                prop="daifatitle"
                :label="$t('memberGroup')"
                >
            </el-table-column>	
            <el-table-column
                :label="$t('status')">
                <template slot-scope="scope">
                    <div>{{scope.row.msg}}</div>
                    <!--     <div>{{scope.row.status=='0'?$t('planing'):$t('ending')}}{{scope[0]}}</div> -->
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination flex-center">
			<span class="el-pagination__total">{{ $t("total") }} {{tableData.length}} {{ $t("items") }}</span>
            <el-pagination 
                background 
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="prev,pager,next"
                :total="tableData.length">
            </el-pagination>
        </div>
	</template>
	<template v-if="broadcasting_read === '0'">
        <span>{{ $t("NoPermissions") }}</span>
    </template>

   <!-- add renwu-->
   <el-dialog
     :title="$t('addRenwu')"
     :visible.sync="dialogVisible"
     :width="$store.state.isMobile? '90%' :'556px'"
     :before-close="handleClose"
   >
     <div class="add-template">
       <el-form ref="form" :model="form">
		  
		  <!--
		  <el-form-item :label="$t('addRenwutime')">

			
		   <el-date-picker
		         v-model="form.plantime"
		         type="datetime"
		         placeholder="選擇日期時間"
				 :picker-options="{ disabledDate: (time) => disabledEndDate(time, departureDate) }">
		       </el-date-picker>
		    </el-form-item>-->





					<el-form-item :label="$t('storeList')">
						<template>
							<div class="flex flex-wrap" style="display: flex">
								<el-select v-model="form.storeid" placeholder="" @change="changeStoreid">
									<template v-for="(item,index) in storelist">
										<el-option :label="item.name" :value="item.storeid"></el-option>
									</template>
								</el-select>
							</div>
						</template>
					</el-form-item>


			<el-form-item :label="$t('addRenwudate')">

				<template>
					<div class="flex flex-wrap" style="display: flex">
						<el-select v-model="form.book_date" placeholder="">
							<template v-for="(item,index) in days">
								<el-option :value="item">{{item}}</el-option>
							</template>
						</el-select>
					</div>
				</template>

		    </el-form-item>

			<el-form-item :label="$t('addRenwutime')">

				<template>
					<div style="display: flex">
						<el-select v-model="form.book_time_hour" placeholder="">
							<el-option value="08">08</el-option>
							<el-option value="09">09</el-option>
							<el-option value="10">10</el-option>
							<el-option value="11">11</el-option>
							<el-option value="12">12</el-option>
							<el-option value="13">13</el-option>
							<el-option value="14">14</el-option>
							<el-option value="15">15</el-option>
							<el-option value="16">16</el-option>
							<el-option value="17">17</el-option>
							<el-option value="18">18</el-option>
							<el-option value="19">19</el-option>
							<el-option value="20">20</el-option>
						</el-select>
						<span>&nbsp;&nbsp;:&nbsp;&nbsp;</span>
						<el-select v-model="form.book_time_min" placeholder="">
							<el-option value="00">00</el-option>
							<el-option value="01">01</el-option>
							<el-option value="02">02</el-option>
							<el-option value="03">03</el-option>
							<el-option value="04">04</el-option>
							<el-option value="05">05</el-option>
							<el-option value="06">06</el-option>
							<el-option value="07">07</el-option>
							<el-option value="08">08</el-option>
							<el-option value="09">09</el-option>
							<el-option value="10">10</el-option>
							<el-option value="11">11</el-option>
							<el-option value="12">12</el-option>
							<el-option value="13">13</el-option>
							<el-option value="14">14</el-option>
							<el-option value="15">15</el-option>
							<el-option value="16">16</el-option>
							<el-option value="17">17</el-option>
							<el-option value="18">18</el-option>
							<el-option value="19">19</el-option>
							<el-option value="20">20</el-option>
							<el-option value="21">21</el-option>
							<el-option value="22">22</el-option>
							<el-option value="23">23</el-option>
							<el-option value="24">24</el-option>
							<el-option value="25">25</el-option>
							<el-option value="26">26</el-option>
							<el-option value="27">27</el-option>
							<el-option value="28">28</el-option>
							<el-option value="29">29</el-option>
							<el-option value="30">30</el-option>
							<el-option value="31">31</el-option>
							<el-option value="32">32</el-option>
							<el-option value="33">33</el-option>
							<el-option value="34">34</el-option>
							<el-option value="35">35</el-option>
							<el-option value="36">36</el-option>
							<el-option value="37">37</el-option>
							<el-option value="38">38</el-option>
							<el-option value="39">39</el-option>
							<el-option value="40">40</el-option>
							<el-option value="41">41</el-option>
							<el-option value="42">42</el-option>
							<el-option value="43">43</el-option>
							<el-option value="44">44</el-option>
							<el-option value="45">45</el-option>
							<el-option value="46">46</el-option>
							<el-option value="47">47</el-option>
							<el-option value="48">48</el-option>
							<el-option value="49">49</el-option>
							<el-option value="50">50</el-option>
							<el-option value="51">51</el-option>
							<el-option value="52">52</el-option>
							<el-option value="53">53</el-option>
							<el-option value="54">54</el-option>
							<el-option value="55">55</el-option>
							<el-option value="56">56</el-option>
							<el-option value="57">57</el-option>
							<el-option value="58">58</el-option>
							<el-option value="59">59</el-option>
						</el-select>
						<span>&nbsp;&nbsp;</span>
						<el-select v-model="form.book_time_type" placeholder="">
							<el-option value="0" :label="$t('scheduledSending')">{{ $t("scheduledSending") }}</el-option>
							<el-option value="1" :label="$t('1interval')">{{ $t("1interval") }}</el-option>
                            <el-option value="2" :label="$t('2interval')">{{ $t("2interval") }}</el-option>
                            <el-option value="3" :label="$t('3interval')">{{ $t("3interval") }}</el-option>
                            <el-option value="4" :label="$t('4interval')">{{ $t("4interval") }}</el-option>
                            <el-option value="5" :label="$t('5interval')">{{ $t("5interval") }}</el-option>
                            <el-option value="10" :label="$t('10interval')">{{ $t("10interval") }}</el-option>
							<el-option value="20" :label="$t('20interval')">{{ $t("20interval") }}</el-option>
							<el-option value="30" :label="$t('30interval')">{{ $t("30interval") }}</el-option>
							<el-option value="40" :label="$t('40interval')">{{ $t("40interval") }}</el-option>
							<el-option value="50" :label="$t('50interval')">{{ $t("50interval") }}</el-option>
							<el-option value="60" :label="$t('60interval')">{{ $t("60interval") }}</el-option>
						</el-select>
					</div>
				</template>
		    </el-form-item>
		     
			  <!-- 
		   <el-form-item :label="$t('renwuType')">
		       <el-select @change="changetype" v-model="form.type" placeholder="">
		           <el-option :label="$t('typewhatsapp')" value="whatsapp"></el-option>
		           <el-option :label="$t('businessApi')" value="businessApi"></el-option>
		         <!--  <el-option :label="$t('typesms')" value="sms"></el-option>
		           <el-option :label="$t('typeEmail')" value="email"></el-option> 
		       </el-select>
		   </el-form-item>-->
		   
		   
		   
   		<el-form-item :label="$t('listName')">
   		  <el-input v-model="form.title"   :rows="1"></el-input>
   		</el-form-item>
   		

		   <el-form-item :label="$t('memberGroupTarget')" prop="excel">									
				<el-select v-model="form.membertarget" :placeholder="$t('pleaseSelect')">
					<el-option :label="$t('memberGroup')" value="group"></el-option>
					<el-option label="Excel" value="excel" v-if="qyid==598 || qyid==605 || qyid==621 || qyid==623"></el-option>
				</el-select>   
			</el-form-item>	

     <el-form-item v-if="form.membertarget=='group'" :label="$t('memberGroup')" prop="excel">
         												
   	    <el-select v-model="form.daifaid" :placeholder="$t('pleaseSelect')" multiple>
   	      <el-option
   	        v-for="item in daifalistData"
   	        :key="item.id"
   	        :label="item.title"
   	        :value="item.id">
   	      </el-option>
   	    </el-select>   
		    </el-form-item>	

			<!--
			<el-form-item label="範本" prop="excel">
				
		 <el-select v-model="form.templateid" placeholder="請選擇">
		   <el-option
			 v-for="item in templistData"
			 :key="item.id"
			 :label="item.title"
			 :value="item.id">
		   </el-option>
		 </el-select>
	   </el-form-item>-->
			
	   
      <el-form-item v-if="form.type=='whatsapp'" :label="$t('templates')" prop="excel">
         
   	    <el-select v-model="form.templateid" :placeholder="$t('pleaseSelect')">
   	      <el-option
   	        v-for="item in templistData"
   	        :key="item.id"
   	        :label="item.title"
   	        :value="item.id">
   	      </el-option>
   	    </el-select>
         </el-form-item>
		 
		 
			<!--
      <el-form-item v-if="form.type=='businessApi'" label="範本" prop="excel">
         
   	    <el-select @change="schange" v-model="form.templateid" placeholder="請選擇">
   	      <el-option
   	        v-for="item in gflist"
   	        :key="item.id"
   	        :label="item.name"
   	        :value="item.name">
   	      </el-option>
   	    </el-select>
		<span v-if="gftmplist[form.templateid]"> {{gftmplist[form.templateid]['components'][0]['text'] }} {{gftmplist[form.templateid]['components'][1]['text'] }} </span>
         </el-form-item>-->

		<el-form-item v-if="form.type=='businessApi'" :label="$t('type')">
			<el-select v-model="form.sendtype" :placeholder="$t('pleaseSelect')">
				<el-option :label="$t('templates')" value="template">
				</el-option>
				<el-option :label="$t('image')" value="image">
				</el-option>
				<el-option :label="$t('wenzi')" value="txt">
				</el-option>
				<el-option :label="$t('button')" value="button" v-if="form.membertarget=='group'">
				</el-option>
			</el-select>
		</el-form-item>

		<el-form-item v-if="form.sendtype=='template'" :label="$t('selectTemplates')">
		 <el-select  v-model="form.metatemplateid" :placeholder="$t('pleaseSelect')">
		   <el-option
			 v-for="item in metaTemplateList"
			 :key="item.id"
			 :label="item.template_name"
			 :value="item.id">
		   </el-option>
		 </el-select>   
		  </el-form-item>	

		<!--
		 <el-form-item v-if="form.type=='businessApi' && form.sendtype=='template'" :label="$t('templateName')">
		  <el-input v-model="form.templateid"   :rows="1"></el-input>
		</el-form-item>-->

		<!-- <el-form-item v-if="form.sendtype=='template' || form.sendtype=='image'" label="圖片">

		 <el-input v-model="form.head_img"   :rows="1"></el-input>-->

		 <el-form-item   v-if="form.sendtype=='button'" 	:label="$t('header')">
		   <el-input v-model="form.header"   :rows="2"></el-input>
		 </el-form-item>

		  <el-form-item v-if="form.sendtype=='image' || form.sendtype=='button'" :label="$t('image')">
				<el-input v-model="form.imgurl"></el-input>
				<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
					:http-request="uploadSectionFile" :on-remove="handleRemove">
					<i slot="default" class="el-icon-plus" />
					<div slot="file" slot-scope="{file}">
						<el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
								<i class="el-icon-zoom-in" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleDownload(file)">
								<i class="el-icon-download" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleRemove(file)">
								<i class="el-icon-delete" />
							</span>
						</span>
					</div>
				</el-upload>

						<!-- <el-image-viewer :z-index="2002" v-if="showViewer" :on-close="closeViewer" :url-list="[dialogImageUrl]"/> -->



			</el-form-item>
		<!-- </el-form-item>-->
 		 
		<!--
		 <el-form-item   v-if="form.type=='businessApi' && form.sendtype=='template'" label="文字1">
		   <el-input v-model="form.msg1"   :rows="2"></el-input>
		 </el-form-item>
 
		 <el-form-item   v-if="form.type=='businessApi' && form.sendtype=='template'" 	label="文字2">
		   <el-input v-model="form.msg2"   :rows="2"></el-input>
		 </el-form-item>-->

		 <el-form-item   v-if="form.sendtype=='txt' || form.sendtype=='button'" 	:label="$t('replyText')">
		   <el-input v-model="form.msg1"   type="textarea" :rows="2"></el-input>
		 </el-form-item>

		 
		 <el-form-item :label="$t('uploadFiles') + ':'" prop="excel" v-if="form.membertarget=='excel'">
            <el-upload class="upload-demo" ref="upload" action :http-request="httpRequest" :before-upload="beforeUpload"
              :on-exceed="handleExceed" :limit="1">
              <el-button slot="trigger" size="small" type="primary">{{ $t("selectFiles") }}</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ $t("uploadTips") }}
              </div>
              <div slot="tip" class="el-upload__tip">
                <a href="temp_broadcast.xlsx">{{ $t("downloadModules") }}</a>
              </div>
            </el-upload>
          </el-form-item>

		 <el-form-item   v-if="form.sendtype=='button'" 	:label="$t('buttonlist')">
		   <el-input v-model="form.buttonlist"   :rows="2"></el-input>
		 </el-form-item>

		 <el-form-item   v-if="form.sendtype=='button'" 	:label="$t('footer')">
		   <el-input v-model="form.footer"   type="textarea" :rows="2"></el-input>
		 </el-form-item>
 
		 
       </el-form>
     </div>
     <span slot="footer" class="dialog-footer">
       <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
       <el-button type="primary" @click="sure">{{
         $t("Sure")
       }}</el-button>
     </span>
   </el-dialog>

   <!-- view renwu -->
   <el-dialog :title="$t('broadcastRecord')" :visible.sync="dialogRecordVisible"
        :width="$store.state.isMobile ? '90%' : '856px'" :before-close="handleRecordClose" class="view-dialog">
            <h4>{{ $t('sentAmount') }}: {{ recordRecordAmount1 }}</h4>
            <h4>{{ $t('deliveredAmount') }}: {{ recordRecordAmount2 }}</h4>
            <h4>{{ $t('readAmount') }}: {{ recordRecordAmount3 }}</h4>
            <h4>{{ $t('failedAmount') }}: {{ recordRecordAmount4 }}</h4>
            <div class="add-template">
                <el-table :data="recordData.slice((recordDataCurrentPage - 1) * recordDataPageSize, recordDataCurrentPage * recordDataPageSize)
                    " stripe style="width: 100%">
                    <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="status" :label="$t('status')" sortable="custom">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status === 'sent'">{{ $t('sent') }} </div>
                            <div v-if="scope.row.status === 'delivered'">{{ $t('delivered') }} </div>
                            <div v-if="scope.row.status === 'read'">{{ $t('read') }} </div>
                            <div v-if="scope.row.status === 'failed'">{{ $t('failed') }} </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination flex-center">
                    <span class="el-pagination__total">{{ $t("total") }} {{ recordData.length }} {{ $t("items") }}</span>
                    <el-pagination background @current-change="handleRecordDataCurrentChange"
                    :current-page="recordDataCurrentPage" :page-size="recordDataPageSize" layout="prev,pager,next"
                    :total="recordData.length"></el-pagination>
                </div>
 
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogRecordVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="dialogRecordVisible = false">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>
   
    </div>
</template>
<script>
import axios from 'axios'
import {tongyong,addRenwu,addRenwu_excel,funk,imageUpload, getMetaTemplate, getStore, getBroadcastRecord} from '@/api'
import {addTemplate} from '@/api'
export default {
    data() {
        return {
			broadcasting_read: '0',
			broadcasting_edit: '0',
			exportcsv: '0',
			qyid: '',
			daifalistData:[],
			type:'whatsapp',
			templistData:[],
			 currentPage: 1,  // 当前页码
			  pageSize: 10,  // 每页显示的行数
            activeName: '0',
            dialogVisible: false,
            dialogRecordVisible: false,
            tab: [
                {label: this.$t('planing'), id: '0'},
                {label: this.$t('ending'), id: '1'},
                {label: this.$t('failing'), id: '-1'}
            ],
			tableData:[],
            recordData: [],
            recordDataCurrentPage: 1,  // 当前页码
            recordDataPageSize: 10,
            recordRecordAmount1: 0,
            recordRecordAmount2: 0,
            recordRecordAmount3: 0,
            recordRecordAmount4: 0,
			gflist:[],
			gftmplist:[],
			metaTemplateList: [],
			status:0,
			fileList: [],
            form: {
                //type: this.$t('typewhatsapp'),
				type: this.$t('businessApi'),
                title: '',
                text: '',
                qyid: '',
                status: '',
                pic: '',
				imgurl: '',
				membertarget: '',
				header: '',
				footer: '',
				msg1: '',
				msg2: '',
				language: '',
				templateid: '',
				buttonlist: ''
            },
			haveone:false,
			havetwo:false,
			days: [],
			storelist: [],
      		storeform: {
				storeid: ''
			},
        }
    },
	created() {
		var user = JSON.parse(window.localStorage.getItem('userinfo'))
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		//this.qyid = user.id
		this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
		this.broadcasting_read = auser.broadcasting_read
    	this.broadcasting_edit = auser.broadcasting_edit
    	this.exportcsv = auser.exportcsv
			   this.gettemplist('')
			   this.getgflist()
			   var today = new Date();
				for (let i = 0; i < 14; i++) {
					var day = new Date(today.getTime() + (24 * 60 * 60 * 1000 * i));
					//console.log(day.getFullYear()+'-'+ parseInt(day.getMonth() + 1)+'-'+day.getDate())
					var dayy = day.getFullYear()+'-'+ parseInt(day.getMonth() + 1)+'-'+day.getDate();
					this.days.push(dayy);
				}
				this.getMetaTemplateList();
				this.getstorelist();
			  },
    methods: {
		disabledEndDate(date, departureDate) {
			// If departureDate then return valid dates after departureDate
			if (departureDate) {
				return date.getTime() < departureDate
			} else {
				// If !departureDate then return valid dates after today
				return date.getTime() < Date.now()
			}
		},
		schange(e,item){
			this.haveone = false
			this.havetwo = false 
			this.form.language = this.gftmplist[e]['language']
			console.log('this.form.language',this.form.language);
		    var tmp = this.gftmplist[e]['components'][0]['text']
			console.log('tmp1',tmp);
				if(tmp != undefined){	
					if( tmp.indexOf('{{') >0){
						console.log('have one ');
						this.haveone=true 
					}
			}
			if(this.gftmplist[e]['components'][1]){
				 tmp = this.gftmplist[e]['components'][1]['text']
				 	console.log('tmp2',tmp);
				if(tmp != undefined){	
					if( tmp.indexOf('{{') >0){
						
						if(this.haveone){
							console.log('have one . ');
							this.havetwo=true;
						}else{
								console.log('have one ');
							this.haveone = true 
						}
					}
				}
			}
			
		},
		uptime(){
			let year = new Date().getFullYear();
			//月份是从0月开始获取的，所以要+1;
			let month = new Date().getMonth() +1;
			//日
			let day = new Date().getDate();
			//时
			let hour = new Date().getHours();
			//分
			let minute = new Date().getMinutes()+2;
			//秒
			let second = new Date().getSeconds();
							
			let time = year + '-' + month + '-' + day + ' ' + hour +':'+minute+':'+second
			
		//	this.form.plantime=time
		},
		changetype(e){
			console.log(e);
			this.type=e
			this.getlist_temp()
			this.getdaifalist()
		},
		addrenwu(){
			this.uptime()
			this.dialogVisible=true;
			this.getlist_temp()
			this.getdaifalist()
		},
		beforeHandleCommand(e){
			console.log(e);
		},
		 // 页面切换方法
		  handleCurrentChange(val) {
		    this.currentPage = val;
		  },
        handleClick(tab, event) {
            console.log(tab.index);
			this.status=tab.index
			if(this.status==2){this.status=-1}
			this.currentPage=1
			 this.gettemplist(this.storeform.storeid)
        },
        handleClose() {
            this.dialogVisible = !this.dialogVisible
        },
        handleRecordClose() {
			this.dialogRecordVisible = !this.dialogRecordVisible
		},
        handleRecordDataCurrentChange(val) {
            this.recordDataCurrentPage = val;
        },
        handlePictureCardPreview() {

        },
        handleRemove() {

        },
		changeTableStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			this.gettemplist(this.storeform.storeid)
		},
		changeStoreid() {
			this.getMetaTemplateList()
			//this.gethuodonglist()
		},
		getstorelist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))
                var auser = JSON.parse(window.localStorage.getItem('auserinfo'))

				let fdata = {
					qyid: auser.qyid,
                    storeid: auser.storeid,
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
						console.log(res);
						this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			},
        // 新增範本点击确定
        sure() {
			//console.log('plantime')
			//console.log(this.form.plantime)

			//console.log('book_date')
			//console.log(this.form.book_date + ', ' + this.form.book_time_hour  + ', ' + this.form.book_time_min + ', ' + this.form.book_time_type)
			
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			console.log(user)
				
			if(!this.form.title) {
				this.$message.error(this.$t('pleaseSelect')+" title");
				return
			}
			if(this.form.plantime==0) {
				this.$message.error(this.$t('pleaseSelect')+" "+ this.$t('time'));
				return
			}
			
			//this.form.qyid= user.id
            this.form.qyid= this.qyid
				
			this.form.status    = 0
			this.form.msg    = 'ready to send'
			 
			 if(this.form.membertarget == "group") {
				this.form.daifaid = this.form.daifaid.join(',');
				addRenwu(this.form).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
						this.dialogVisible= false;
						this.gettemplist(this.storeform.storeid);
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			 }
			 else if(this.form.membertarget == "excel") {
				let paramsData = new FormData();
				// 将上传文件数组依次新增到参数paramsData中
				console.log("filelist", this.fileList);
				this.fileList.forEach((x) => {
					console.log(x.file);
					paramsData.append("file", x.file);
				});
				//paramsData.append("qyid", user.id);
                paramsData.append("qyid", this.qyid);
				paramsData.append("storeid", this.form.storeid);
				paramsData.append("title", this.form.title);
				paramsData.append("plantime", this.form.plantime);
				paramsData.append("type", this.form.type);
				paramsData.append("text", this.form.text);
				paramsData.append("pic", this.form.pic);
				paramsData.append("status", this.form.status);
				paramsData.append("imgurl", this.form.imgurl);
				paramsData.append("msg", this.form.msg);
				paramsData.append("sendtype", this.form.sendtype);
				paramsData.append("msg1", this.form.msg1);
				paramsData.append("msg2", this.form.msg2);
				paramsData.append("buttonlist", this.form.buttonlist);
				paramsData.append("language", this.form.language);
				paramsData.append("header", this.form.header);
				paramsData.append("footer", this.form.footer);
				paramsData.append("book_date", this.form.book_date);
				paramsData.append("book_time_hour", this.form.book_time_hour);
				paramsData.append("book_time_min", this.form.book_time_min);
				paramsData.append("book_time_type", this.form.book_time_type);
				paramsData.append("templateid", this.form.templateid);
				paramsData.append("metatemplateid", this.form.metatemplateid);

				/*
				addRenwu_excel(paramsData).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
						this.dialogVisible= false;
						this.gettemplist(this.storeform.storeid);
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});*/
				axios.post("https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_sendrw_insert_fromexcel", paramsData).then(res => {
					console.log(res.data);

					if (res.data.code == 1) {
						this.$message({
							type: "success",
							message: res.data.msg,
						});
						this.dialogVisible= false;
						this.gettemplist(this.storeform.storeid);
					} else {
						this.$message({
							type: "error",
							message: res.data.msg,
						});
					}

				})


				//type: this.$t('businessApi'),
                //title: '',
                //text: '',
                //qyid: '',
                //status: '',
                //pic: '',
				//imgurl: '',
				//membertarget: ''
			 }

			 
        },
		baogao(item){
			let url='https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=api_tongyong&sjk=messenger_sendlist&action=list&moresearch=rwid&ex=xls&rwid='+item.id+'&addtime='+item.addtime
		    window.open(url)
		},
		//删除某个
		delitem(id){
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
			
			    console.log('del..');
				let  fdata= {
						sjk: 'messenger_sendrwlist',
						action:'del',
						id:id
					}
				tongyong(fdata).then(res => {
					if(res.code==1){
					  console.log(res);
					  this.gettemplist(this.storeform.storeid)
					}else{
						this.$message({
							type: 'error',
							message: res.msg
						})
					}    
				})
			}).catch(_ => {
			
			　 
			
			})
			
			
		},
        broadcastrecord(data){
			let fdata = {
				qyid: this.qyid,
                storeid: data.storeid,
				broadcastid: data.id
			};
            console.log(fdata)
			getBroadcastRecord(fdata).then((res) => {
				if (res.code == 1) {
					console.log('getBroadcastRecordgetBroadcastRecordgetBroadcastRecordgetBroadcastRecordgetBroadcastRecord');
                    console.log(res);
					this.recordData = res.record
                    this.recordRecordAmount1 = parseInt(res.sentcount) + parseInt(res.deliveredcount) + parseInt(res.readcount)
                    this.recordRecordAmount2 = parseInt(res.deliveredcount) + parseInt(res.readcount)
                    this.recordRecordAmount3 = parseInt(res.readcount)
                    this.recordRecordAmount4 = parseInt(res.failedcount)
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
            this.dialogRecordVisible = true
		},
		getMetaTemplateList() {
			this.show=true
			console.log("go list");
			var user = JSON.parse(window.localStorage.getItem("userinfo"));

			let fdata = {
				//qyid: user.id,
                qyid: this.qyid,
				storeid: this.form.storeid
			};
			getMetaTemplate(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.metaTemplateList = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		// 我的任务列表
		gettemplist(storeid){
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
		 
					 
			 
			let  fdata= {
					sjk: 'messenger_sendrwlist',
					action:'list',
					status:this.status,
					moresearch:'status,',
					//qyid:user.id,
                    qyid:this.qyid,
					storeid: storeid
				}
			tongyong(fdata).then(res => {
				if(res.code==1){
				  console.log(res);
				  this.tableData=res.data
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})
		},
		
		// 官方模板列表
		getgflist(){
			console.log('go guanfang tmeplate');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
		
			let  fdata= {
					sjk: 'messenger_templatelist',
					action:'list',
					status:this.status,
					moresearch:'status,',
					//qyid:user.id,
                    qyid:this.qyid,
					do:'whats_template'
				}
			funk(fdata).then(res => {
				if(res.data.length>0){
				 
				  this.gflist=res.data
				  this.gftmplist=res.mdata
				   console.log('gflist',this.gflist);
				   console.log('gftmplist',this.gftmplist);
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})
		},
		
		
		// 我的代发列表
		getdaifalist() {
		  console.log("go taocan");
		  var user = JSON.parse(window.localStorage.getItem("userinfo"));
		
		  let fdata = {
		    sjk: "messenger_daifafile",
		    action: "list",
			// type:this.type,
			// moresearch:'type,',
		    //qyid: user.id,
            qyid: this.qyid,
		    };
		  tongyong(fdata).then((res) => {
		    if (res.code == 1) {
		      console.log(res);
		      this.daifalistData = res.data;
		    } else {
		      this.$message({
		        type: "error",
		        message: res.msg,
		      });
		    }
		  });
		},
		
		//模板列表
		 getlist_temp() {
		  console.log("go messenger_templatelist");
		  var user = JSON.parse(window.localStorage.getItem("userinfo"));
		
		  let fdata = {
		    sjk: "messenger_templatelist",
		    action: "list",
			status:1,
		
			moresearch:'status,',
		    //qyid: user.id,
            qyid: this.qyid,
		    };
		  tongyong(fdata).then((res) => {
		    if (res.code == 1) {
		      console.log(res);
		      this.templistData = res.data;
		    } else {
		      this.$message({
		        type: "error",
		        message: res.msg,
		      });
		    }
		  });
		},

		httpRequest(option) {
      		this.fileList.push(option);
    	},
		// 上传前处理
		beforeUpload(file) {
			let fileSize = file.size;
			const FIVE_M = 5 * 1024 * 1024;
			//大于5M，不允许上传
			if (fileSize > FIVE_M) {
				this.$message.error(this.$t('max5mb'));
				return false;
			}
			//判断文件类型，必须是xlsx格式
			let fileName = file.name;
			let reg = /^.+(\.xlsx)$/;
			if (!reg.test(fileName)) {
				this.$message.error(this.$t('xlsxOnly'));
				return false;
			}
			return true;
		},
		// 文件数量过多时提醒
		handleExceed() {
			this.$message({ type: "error", message: this.$t('1attachment') });
		},

		uploadSectionFile(params) {
				const file = params.file,
					fileType = file.type,
					isImage = fileType.indexOf('image') !== -1,
					isLt2M = file.size / 1024 / 1024 < 2;
				// 这里常规检验，看项目需求而定
				if (!isImage) {
					this.$message.error(this.$t('imageFormatOnly'));
					return;
				}
				if (!isLt2M) {
					this.$message.error(this.$t('imageSizeOnly'));
					return;
				}
				// 根据后台需求数据格式
				const form1 = new FormData();
				// 文件对象
				form1.append('file', file);
				// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
				// form.append("clientType", 'xxx');
				// 项目封装的请求方法，下面做简单介绍


				imageUpload(form1).then(res => {
					//自行处理各种情况
					console.log('res', res)
					this.form.imgurl = res
				}).catch(() => {
					// xxx
				});
			},
		
		
    }
}
</script>
<style lang="scss" scoped>
	.el-pagination__total {
		display: inline-block;
		font-size: 13px;
		min-width: 35.5px;
		height: 28px;
		line-height: 28px;
		vertical-align: top;
		box-sizing: border-box;
	}
    .pagination{
        width: 100%;
        margin: 30px auto;
    }
    ::v-deep .el-select{
            width: 100%;   
    }
	@media screen and (max-width: 768px){
		
		::v-deep .el-form-item{
			margin-bottom: 0px;
		}
		::v-deep .el-dialog__body{
			padding: 10px 20px;
		}
    }
</style>